import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ textAlign: 'center', py: 4, px: 2, borderTop: 1, borderColor: 'divider', color: 'text.secondary' }}>
      <Typography variant="body2">© Anastasiya Masalava. Last updated October 2026.</Typography>
    </Box>
  );
};

export default Footer;
